/* vl perf: product-card variant image/swatch script, moved from a copy inside every card (product-card-2.liquid) to one shared file. Logic unchanged; runs once per page. */
(function(){ if (window.__vlCardVariants) return; window.__vlCardVariants = true;

(function () {

  function initVariantCard(card) {
    if (!card || card.dataset.variantInitDone) return;

    const mapEl = card.querySelector('[data-variant-image-map]');
    if (!mapEl) return;

    const map = JSON.parse(mapEl.textContent);

    function getVariantsWithRetry(callback, attempts = 0) {
      const variantsDataEl = card.querySelector('[data-pcard-variant-picker] script');

      if (variantsDataEl) {
        try {
          const variants = JSON.parse(variantsDataEl.textContent);
          callback(variants);
        } catch (e) {
          console.warn('Variant JSON parse failed', e);
        }
      } else if (attempts < 12) {
        setTimeout(() => {
          getVariantsWithRetry(callback, attempts + 1);
        }, 50);
      }
    }

    function updateThisCard(variant) {
      if (!variant) return;

      const data = map[String(variant.id)];
      if (!data) return;

      const mainImg = card.querySelector('.m-card-img-main');
      const hoverImg = card.querySelector('.m-card-img-hover');

      if (mainImg && data.img1) {
        mainImg.src = data.img1;
        mainImg.removeAttribute('srcset');
      }

      if (hoverImg) {
        if (data.img2) {
          hoverImg.src = data.img2;
          hoverImg.removeAttribute('srcset');
          card.classList.add('m-product-card--show-second-img');
        } else {
          card.classList.remove('m-product-card--show-second-img');
        }
      }

      const titleSpan = card.querySelector('[data-variant-title]');
      if (titleSpan) {
        titleSpan.textContent =
          variant.title && variant.title !== 'Default Title'
            ? ' - ' + variant.title
            : '';
      }

      card.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variant.id);
        link.href = url.pathname + url.search;
      });

      // Update Closeout Badges and Inventory blocks dynamically on Variant Change
      card.querySelectorAll('[data-variant-id]').forEach(el => {
        if (el.dataset.variantId === String(variant.id)) {
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
    }

    function findVariantFromOptions() {
      const variants = card._variants || [];
      if (!variants.length) return null;

      const selectedOptions = [];

      card.querySelectorAll('.m-product-option--node__label[data-selected="true"]').forEach(el => {
        selectedOptions.push(el.dataset.value);
      });

      return variants.find(v => {
        return v.options.every((opt, i) => opt === selectedOptions[i]);
      });
    }

    // Swatch click handler
    card.addEventListener('click', (e) => {
      const swatch = e.target.closest('.m-product-option--node__label');
      if (!swatch) return;

      card.querySelectorAll(`[data-option-position="${swatch.dataset.optionPosition}"]`)
        .forEach(el => el.removeAttribute('data-selected'));

      swatch.setAttribute('data-selected', 'true');

      const variant = findVariantFromOptions();
      updateThisCard(variant);
    });

    // Init AFTER variants are ready
    getVariantsWithRetry((variants) => {
      if (!variants || !variants.length) return;

      card._variants = variants;

      const initialVariant = variants.find(v => v.available) || variants[0];
      updateThisCard(initialVariant);
    });

    card.dataset.variantInitDone = "true";
  }

  function initAllCards() {
    document.querySelectorAll('.m-product-card').forEach(initVariantCard);
  }

  // Delay init slightly (important for sliders / async DOM)
  setTimeout(initAllCards, 50);

  // Watch for infinite load / dynamic inserts
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches?.('.m-product-card')) {
          initVariantCard(node);
        } else {
          node.querySelectorAll?.('.m-product-card').forEach(initVariantCard);
        }
      });
    });
  });

  // Scope it better if container exists
  const container = document.querySelector('[data-product-container]');
  observer.observe(container || document.body, {
    childList: true,
    subtree: true
  });

})();

})();
